import moment from "moment-timezone";
import numeral from "numeral";
import url from "@/services/Url";
import _ from "lodash";
import axios from "axios";
import platform from "platform";

export const func = {
  getUrl() {
    return url;
  },
  getTimeZoneServidor() {
    return "-03:00";
  },
  booleanToString: (obj) => {
    return obj === true ? "1" : "0";
  },
  stringToBoolean: (obj) => {
    return obj === "1" ? true : false;
  },
  checkToString: (obj) => {
    return obj.toString() === "checked" ? "1" : "0";
  },
  stringToChecked: (obj) => {
    return obj === "1" ? "checked" : "uncheck";
  },
  generateUuidv4: () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  },
  isNumber: (n) => {
    return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
  },
  isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
  },
  isInteger(value) {
    if (value === null || value === undefined) {
      return false;
    }

    if (typeof value === "string" && value.trim() === "") {
      return false;
    }

    // Converte o valor para um número usando o operador unário +
    const numericValue = +value;

    // Verifica se o valor convertido é um número válido
    if (isNaN(numericValue)) {
      return false;
    }

    // Verifica se o valor convertido é um número inteiro
    return Number.isInteger(numericValue);
  },
  isEquivalent(a, b) {
    // Create arrays of property names
    var aProps = a ? Object.getOwnPropertyNames(a) : "";
    var bProps = b ? Object.getOwnPropertyNames(b) : "";

    // If number of properties is different,
    // objects are not equivalent
    if (aProps.length != bProps.length) {
      return false;
    }

    for (var i = 0; i < aProps.length; i++) {
      var propName = aProps[i];

      // If values of same property are not equal,
      // objects are not equivalent
      if (a[propName] !== b[propName]) {
        return false;
      }
    }

    // If we made it this far, objects
    // are considered equivalent
    return true;
  },
  // convertModelToFormData(model, form, namespace = "") {
  //   let formData = form || new FormData();

  //   for (let propertyName in model) {
  //     if (!model[propertyName] && !this.isNumber(model[propertyName])) continue;
  //     let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
  //     let formKeyFile = namespace
  //       ? `${namespace}.${propertyName}`
  //       : propertyName;
  //     if (model[propertyName] instanceof Date) {
  //       formData.append(
  //         formKey,
  //         moment(String(model[propertyName])).format("YYYY-MM-DD HH:mm:ss")
  //       );
  //     } else if (model[propertyName] instanceof Array) {
  //       model[propertyName].forEach((element, index) => {
  //         const tempFormKey = `${formKey}[${index}]`;
  //         this.convertModelToFormData(element, formData, tempFormKey);
  //       });
  //     } else if (
  //       typeof model[propertyName] === "object" &&
  //       !(model[propertyName] instanceof File)
  //     ) {
  //       this.convertModelToFormData(model[propertyName], formData, formKey);
  //     } else {
  //       if (model[propertyName] instanceof File) {
  //         formData.append(formKeyFile, model[propertyName]);
  //       } else {
  //         formData.append(formKey, model[propertyName].toString());
  //       }
  //     }
  //   }
  //   return formData;
  // },
  convertModelToFormData(model, form, namespace = "") {
    let formData = form || new FormData();

    for (let propertyName in model) {
      if (!model[propertyName] && !this.isNumber(model[propertyName])) continue;
      let formKey = namespace ? `${namespace}.${propertyName}` : propertyName;

      if (model[propertyName] instanceof Date) {
        formData.append(
          formKey,
          moment(String(model[propertyName])).format("YYYY-MM-DD HH:mm:ss")
        );
      } else if (model[propertyName] instanceof Array) {
        model[propertyName].forEach((element, index) => {
          const tempFormKey = `${formKey}[${index}]`;
          if (typeof element === "string") {
            formData.append(tempFormKey, element);
          } else {
            this.convertModelToFormData(element, formData, tempFormKey);
          }
        });
      } else if (
        typeof model[propertyName] === "object" &&
        !(model[propertyName] instanceof File)
      ) {
        this.convertModelToFormData(model[propertyName], formData, formKey);
      } else {
        formData.append(formKey, model[propertyName]);
      }
    }

    return formData;
  },
  getColors() {
    var colors = [
      "bg-light-primary text-primary",
      "bg-light-success text-success",
      "bg-light-info text-info",
      "bg-light-warning text-warning",
      "bg-light-danger text-danger",
      "bg-primary text-inverse-primary",
      "bg-success text-inverse-success",
      "bg-info text-inverse-info",
      "bg-warning text-inverse-warning",
      "bg-danger text-inverse-danger",
      "bg-dark text-inverse-dark",
    ];
    return colors;
  },
  getRandomIntInclusive: function (min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  },
  getColorRandom() {
    return this.getColors()[
      this.getRandomIntInclusive(0, this.getColors().length - 1)
    ];
  },
  formatarData(value) {
    if (value) {
      return moment(String(value)).format("DD/MM/YYYY");
    }
  },
  formatarDataHora(value) {
    if (value) {
      return moment(String(value)).format("DD/MM/YYYY HH:mm:ss");
    }
  },
  formatarDataHoraFusoHorario(value) {
    if (value) {
      const dataUTC = moment.utc(value);
      const timeZone = moment.tz.guess();
      const dataLocal = dataUTC.tz(timeZone);

      return moment(dataLocal._d).format("DD/MM/YYYY HH:mm:ss");
    }
  },
  formatarDataHoraCustomizadaFusoHorario(value) {
    if (value) {
      const dataUTC = moment.utc(value);
      const timeZone = moment.tz.guess();
      const dataLocal = dataUTC.tz(timeZone);

      return moment(dataLocal._d).format("DD MMM YYYY, HH:mm A");
    }
  },
  formatarDataHoraConsulta(value) {
    if (value) {
      return moment(String(value)).format("YYYY-MM-DDTHH:mm:ss");
    }
  },
  formatarDataCustomizada(value) {
    if (value) {
      const data = moment(value);
      const dataAtual = moment();
      const diffDays = dataAtual.diff(data, "days");

      if (diffDays >= 30 && data.year() === dataAtual.year()) {
        return data.format("DD MMMM");
      } else if (diffDays > 1 && diffDays < 30) {
        return `${diffDays} dias atrás`;
      } else if (
        diffDays === 1 ||
        (diffDays === 0 && data.day() != dataAtual.day())
      ) {
        return "Ontem";
      } else if (diffDays === 0) {
        return data.format("HH:mm A");
      } else {
        return data.format("DD/MM/YYYY");
      }
    }
  },
  formatarDataCustomizadaFusoHorario(value) {
    if (value) {
      const dataUTC = moment.utc(value);
      const timeZone = moment.tz.guess();
      const dataLocal = dataUTC.tz(timeZone);
      const dataAtualUTC = this.removerFusoHorario(new Date());
      const dataAtualLocal = moment.utc(dataAtualUTC).tz(timeZone);
      const diffDays = dataAtualLocal.diff(dataLocal, "days");

      if (diffDays >= 30 && dataLocal.year() === dataAtualLocal.year()) {
        return moment(dataLocal._d).format("DD MMMM");
      } else if (diffDays > 1 && diffDays < 30) {
        return `${diffDays} dias atrás`;
      } else if (
        diffDays === 1 ||
        (diffDays === 0 && dataLocal.day() != dataAtualLocal.day())
      ) {
        return "Ontem";
      } else if (diffDays === 0) {
        return moment(dataLocal._d).format("HH:mm A");
      } else {
        return moment(dataLocal._d).format("DD/MM/YYYY");
      }
    }
  },
  removerFusoHorario(data) {
    if (data) {
      if (!(data instanceof Date)) {
        data = new Date(data);
      }
      const timeZoneOffset = data.getTimezoneOffset();

      return new Date(data.getTime() + timeZoneOffset * 60 * 1000);
    }
  },
  formatarHora(value) {
    if (value) {
      return moment(String(value)).format("HH:mm:ss");
    }
  },
  formatarNumero(numero) {
    let numeroFormatado = parseFloat(numero);
    if (isNaN(numeroFormatado)) {
      numeroFormatado = 0;
    }

    return numeral(numeroFormatado).format("0.00");
  },
  formatarNumeroCasas(numero, casasDecimais) {
    let formato = "0." + "0".repeat(casasDecimais);
    return numeral(numero).format(formato);
  },
  retornarValoresJson(object) {
    var values = [];
    var keys = Object.keys(object);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (
        !k.includes("Data") &&
        !k.includes("Message") &&
        !k.includes("Success")
      ) {
        values.push(object[k]);
      }
    }
    return values;
  },
  retornarValoresJsonAtalhoSimples(object) {
    var values = [];
    var keys = Object.keys(object);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (
        !k.includes("Data") &&
        !k.includes("Message") &&
        !k.includes("Success")
      ) {
        const error = object[k];
        const elemento = k;
        values.push({ error, elemento });
      }
    }
    return values;
  },
  retornarValoresJsonAtalho(object, mapper) {
    var values = [];
    var keys = Object.keys(object);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (
        !k.includes("Data") &&
        !k.includes("Message") &&
        !k.includes("Success")
      ) {
        const error = object[k];
        const elemento = k;
        const keyMapper = k.replace(/\[\d+\]/g, "");
        const tab = mapper[keyMapper] ? mapper[keyMapper][0] : "";
        const tabID = mapper[keyMapper] ? mapper[keyMapper][1] : "";
        const onClick = mapper[keyMapper] ? mapper[keyMapper][2] : "";
        const indices = this.retornarIndices(k);
        values.push({ error, elemento, tab, tabID, onClick, indices });
      }
    }
    return values;
  },
  retornarIndices(string) {
    const indices = [];
    const pattern = /\[(\d+)\]/g;
    let match;

    while ((match = pattern.exec(string)) !== null) {
      indices.push(parseInt(match[1]));
    }

    return indices;
  },
  setMask(value, mask, masked) {
    var tokens = {
      "#": {
        pattern: /\d/,
      },
      X: {
        pattern: /[0-9a-zA-Z]/,
      },
      S: {
        pattern: /[a-zA-Z]/,
      },
      A: {
        pattern: /[a-zA-Z]/,
        transform: (v) => v.toLocaleUpperCase(),
      },
      a: {
        pattern: /[a-zA-Z]/,
        transform: (v) => v.toLocaleLowerCase(),
      },
      "!": {
        escape: true,
      },
    };
    value = value || "";
    mask = mask || "";
    var iMask = 0;
    var iValue = 0;
    var output = "";
    while (iMask < mask.length && iValue < value.length) {
      var cMask = mask[iMask];
      var masker = tokens[cMask];
      var cValue = value[iValue];
      if (masker && !masker.escape) {
        if (masker.pattern.test(cValue)) {
          output += masker.transform ? masker.transform(cValue) : cValue;
          iMask++;
        }
        iValue++;
      } else {
        if (masker && masker.escape) {
          iMask++; // take the next mask char and treat it as char
          cMask = mask[iMask];
        }
        if (masked) output += cMask;
        if (cValue === cMask) iValue++; // user typed the same char
        iMask++;
      }
    }

    // fix mask that ends with a char: (#)
    var restOutput = "";
    while (iMask < mask.length && masked) {
      var cMask2 = mask[iMask];
      if (tokens[cMask2]) {
        restOutput = "";
        break;
      }
      restOutput += cMask2;
      iMask++;
    }
    return output + restOutput;
  },
  unMask(value) {
    if (value !== null && value !== undefined && value !== "") {
      value = value.replace(/[^a-z0-9]/gi, "");
    }
    return value;
  },
  blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  },
  dataToBlob(data) {
    const base64String = data.FileContents;
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: data.ContentType });
    return blob;
  },
  base64ToBlob(data) {
    const base64String = data;
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: data.ContentType });
    return blob;
  },
  extractBase64Data(inputString) {
    const regex = /base64,(.*)/;
    const match = regex.exec(inputString);

    if (match && match.length > 1) {
      return match[1];
    } else {
      return null;
    }
  },
  checkEmail(email) {
    // eslint-disable-next-line
    //const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    // eslint-disable-next-line no-useless-escape
    const reg = /^\w+([\.-]?\w+)*(\+\w+)?@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (reg.test(email)) return false; //false - email válido
    return true; //true - email inválido
  },

  validarCST(cst) {
    if (cst !== undefined && cst !== null && cst !== "" && cst.length === 3) {
      var origem = cst.substring(0, 1);
      var operacao = cst.substring(1, 3);

      // Verificar a origem da mercadoria ou serviço
      switch (origem) {
        case "0":
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
          // Verificar a operação
          switch (operacao) {
            case "00":
            case "10":
            case "20":
            case "30":
            case "40":
            case "41":
            case "50":
            case "51":
            case "60":
            case "70":
            case "90":
              return true; // CST válido
            default:
              return false; // Operação inválida
          }
        default:
          return false; // Origem inválida
      }
    } else {
      return false; // CST inválido
    }
  },

  validarCSOSN(csosn) {
    if (
      csosn !== undefined &&
      csosn !== null &&
      csosn !== "" &&
      csosn.length === 4
    ) {
      var origem = csosn.substring(0, 1);
      var operacao = csosn.substring(1, 4);

      // Verificar a origem da mercadoria ou serviço
      switch (origem) {
        case "0":
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
          // Verificar a operação
          switch (operacao) {
            case "101":
            case "102":
            case "103":
            case "201":
            case "202":
            case "203":
            case "300":
            case "400":
            case "500":
            case "900":
              return true; // CSOSN válido
            default:
              return false; // Operação inválida
          }
        default:
          return false; // Origem inválida
      }
    } else {
      return false; // CSOSN inválido
    }
  },

  validarCPFCNPJ(valor) {
    // Remove caracteres não numéricos
    valor = valor.replace(/[^\d]+/g, "");

    // CPF
    if (valor.length === 11) {
      let cpf = valor;

      // Verifica se todos os dígitos são iguais
      if (/^(\d)\1+$/.test(cpf)) return false;

      // Calcula o primeiro dígito verificador
      let soma = 0;
      for (let i = 0; i < 9; i++) {
        soma += parseInt(cpf.charAt(i)) * (10 - i);
      }
      let resto = 11 - (soma % 11);
      let digitoVerificador = resto === 10 || resto === 11 ? 0 : resto;

      // Verifica o primeiro dígito verificador
      if (digitoVerificador !== parseInt(cpf.charAt(9))) return false;

      // Calcula o segundo dígito verificador
      soma = 0;
      for (let i = 0; i < 10; i++) {
        soma += parseInt(cpf.charAt(i)) * (11 - i);
      }
      resto = 11 - (soma % 11);
      digitoVerificador = resto === 10 || resto === 11 ? 0 : resto;

      // Verifica o segundo dígito verificador
      if (digitoVerificador !== parseInt(cpf.charAt(10))) return false;

      return true; // CPF válido
    }

    // CNPJ
    if (valor.length === 14) {
      let cnpj = valor;

      // Verifica se todos os dígitos são iguais
      if (/^(\d)\1+$/.test(cnpj)) return false;

      // Calcula o primeiro dígito verificador
      let soma = 0;
      let peso = 2;
      for (let i = 11; i >= 0; i--) {
        soma += parseInt(cnpj.charAt(i)) * peso;
        peso = peso === 9 ? 2 : peso + 1;
      }
      let resto = soma % 11;
      let digitoVerificador = resto < 2 ? 0 : 11 - resto;

      // Verifica o primeiro dígito verificador
      if (digitoVerificador !== parseInt(cnpj.charAt(12))) return false;

      // Calcula o segundo dígito verificador
      soma = 0;
      peso = 2;
      for (let i = 12; i >= 0; i--) {
        soma += parseInt(cnpj.charAt(i)) * peso;
        peso = peso === 9 ? 2 : peso + 1;
      }
      resto = soma % 11;
      digitoVerificador = resto < 2 ? 0 : 11 - resto;

      // Verifica o segundo dígito verificador
      if (digitoVerificador !== parseInt(cnpj.charAt(13))) return false;

      return true; // CNPJ válido
    }

    return false; // Tamanho inválido para CPF ou CNPJ
  },
  validarChaveAcesso(chaveAcesso) {
    if (chaveAcesso.length !== 44) {
      return false;
    }

    const regex = /^[0-9]*$/;
    if (!regex.test(chaveAcesso)) {
      return false;
    }

    const digitos = chaveAcesso.slice(0, 43);
    const digitoVerificador = parseInt(chaveAcesso[43]);

    let soma = 0;
    let peso = 2;

    for (let i = digitos.length - 1; i >= 0; i--) {
      soma += parseInt(digitos[i]) * peso;
      peso = peso === 9 ? 2 : peso + 1;
    }

    const resto = soma % 11;
    const digitoCalculado = resto < 2 ? 0 : 11 - resto;

    return digitoVerificador === digitoCalculado;
  },
  calcularDigitoVerificador(digitos) {
    const pesos = [2, 3, 4, 5, 6, 7, 8, 9];
    let soma = 0;
    for (let i = digitos.length - 1, j = 0; i >= 0; i--, j++) {
      const digito = parseInt(digitos[i]);
      soma += digito * pesos[j % 8];
    }
    const resto = soma % 11;
    let digitoVerificador;
    if (resto === 0 || resto === 1) {
      digitoVerificador = 0;
    } else {
      digitoVerificador = 11 - resto;
    }
    return digitoVerificador;
  },

  async formatarMensagem(mensagem) {
    let resultadoFormatado = [];
    try {
      const linhas = mensagem.split("\n");

      let elementoAtual = null;
      let valorInvalido = null;

      for (let i = 0; i < linhas.length; i++) {
        const linha = linhas[i];

        if (linha.includes("Erro:")) {
          const matchElemento = linha.match(
            /'http:\/\/www\.portalfiscal\.inf\.br\/nfe:(.*?)'/
          );
          const matchValor = linha.match(/The value '([^']+)'/);

          if (matchElemento && matchValor) {
            elementoAtual = matchElemento[1];
            valorInvalido = matchValor[1];

            resultadoFormatado.push({
              erroFormatado: `${elementoAtual} - '${valorInvalido}' é inválido`,
              tagErro: matchElemento[0],
            });
          } else {
            const incompleteMatch = linha.match(
              /The element '(.+?)' in namespace '(.+?)' has (invalid child element|incomplete content) '(.+?)' in namespace '(.+?)'. List of possible elements expected: '(.+?)' in namespace '(.+?)'./
            );

            if (incompleteMatch) {
              const elementoPai = incompleteMatch[1];
              const elementoFilho = incompleteMatch[4];
              const possiveisElementos = incompleteMatch[7];

              resultadoFormatado.push({
                erroFormatado: `O elemento '${elementoPai}' tem um elemento filho '${elementoFilho}' inválido ou incompleto. Os elementos possíveis são '${possiveisElementos}'`,
                tagErro: incompleteMatch[0],
              });
            }
          }
        }
      }
    } catch (error) {
      resultadoFormatado.push({
        erroFormatado: "",
        tagErro: error,
      });
    }
    return resultadoFormatado;
  },

  async dadosEmailNFe(chave) {
    let dadosEmail = {
      emails: [],
      assuntoEmail: "NF-e " + chave,
      mensagemEmail:
        "<H3>Prezado cliente,</H3><br/>Voc&ecirc; est&aacute; recebendo a Nota Fiscal Eletr&ocirc;nica. Al&eacute;m disso, junto com a mercadoria seguir&aacute; o DANFE (Documento Auxiliar da Nota Fiscal Eletr&ocirc;nica), impresso em papel que acompanha o transporte das mesmas.</p><p>Anexo &agrave; este e-mail voc&ecirc; est&aacute; recebendo tamb&eacute;m o arquivo XML da Nota Fiscal Eletr&ocirc;nica. Este arquivo deve ser armazenado eletronicamente por sua empresa pelo prazo de 05 (cinco) anos, conforme previsto na legisla&ccedil;&atilde;o tribut&aacute;ria (Art. 173 do C&oacute;digo Tribut&aacute;rio Nacional e &sect; 4&ordm; da Lei 5.172 de 25/10/1966).</p><br/><p>O DANFE em papel pode ser arquivado para apresenta&ccedil;&atilde;o ao fisco quando solicitado. Todavia, se sua empresa tamb&eacute;m for emitente de NF-e, o arquivamento eletr&ocirc;nico do XML de seus fornecedores &eacute; obrigat&oacute;rio, sendo pass&iacute;vel de fiscaliza&ccedil;&atilde;o.</p><br/><p>Para se certificar que esta NF-e &eacute; v&aacute;lida, queira por favor consultar sua autenticidade no site nacional do projeto NF-e (www.nfe.fazenda.gov.br), utilizando a chave de acesso " +
        chave +
        " .<br/>&nbsp;</p>",
      anexosEmail: [],
    };
    return dadosEmail;
  },

  async dadosEmailCCe(chave) {
    let dadosEmail = {
      emails: [],
      assuntoEmail: "CCe " + chave,
      mensagemEmail:
        "<H3>Prezado cliente,</H3><br/>Voc&ecirc; est&aacute; recebendo a Carta de Correção Eletr&ocirc;nica. Este arquivo deve ser armazenado eletronicamente por sua empresa pelo prazo de 05 (cinco) anos, conforme previsto na legisla&ccedil;&atilde;o tribut&aacute;ria (Art. 173 do C&oacute;digo Tribut&aacute;rio Nacional e &sect; 4&ordm; da Lei 5.172 de 25/10/1966).</p><p>A CC-e em papel pode ser arquivado para apresenta&ccedil;&atilde;o ao fisco quando solicitado. Todavia, se sua empresa tamb&eacute;m for emitente de CC-e, o arquivamento eletr&ocirc;nico do XML de seus fornecedores &eacute; obrigat&oacute;rio, sendo pass&iacute;vel de fiscaliza&ccedil;&atilde;o.</p><br/><p>Para se certificar que esta CC-e &eacute; v&aacute;lida, queira por favor consultar sua autenticidade no site nacional do projeto NF-e (www.nfe.fazenda.gov.br), utilizando a chave de acesso " +
        chave +
        " .<br/>&nbsp;</p>",
      anexosEmail: [],
    };
    return dadosEmail;
  },

  escapeRegExp(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  },

  async consultarCNPJ(cnpj) {
    const cnpjLimpo = cnpj.replace(/[^\d]/g, "");

    const response = await axios.get(
      `https://publica.cnpj.ws/cnpj/${cnpjLimpo}`
    );
    return response;
  },

  async consultarIpExterno() {
    const response = await axios.get(`https://api.ipify.org/?format=json`);
    return response.data.ip;
  },
  retornarNavegador() {
    return platform.name;
  },
  async retornarSistemaOperacional() {
    var sistema = platform.os.family || "Outro";
    var versao = platform.os.version || "";

    try {
      if (sistema === "Windows" && versao === "10") {
        const ua = await navigator.userAgentData.getHighEntropyValues([
          "platformVersion",
        ]);
        if (navigator.userAgentData.platform === "Windows") {
          const majorPlatformVersion = parseInt(
            ua.platformVersion.split(".")[0]
          );
          if (majorPlatformVersion >= 13) {
            return "Windows 11";
          }
        }
      }
    } catch (error) {
      return `${sistema} ${versao}`;
    }

    return `${sistema} ${versao}`;
  },
  retornarTipoDispositivo() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const iPadOS13Up =
      window.navigator.platform === "MacIntel" &&
      window.navigator.maxTouchPoints > 1;

    if (userAgent.includes("windows")) {
      return "Windows";
    } else if (userAgent.includes("ipod")) {
      return "Ipod";
    } else if (userAgent.includes("ipad") || iPadOS13Up) {
      return "Ipad";
    } else if (userAgent.includes("dingtalk")) {
      return "Dingding";
    } else if (userAgent.includes("micromessenger")) {
      return "Wechat";
    } else if (userAgent.includes("miniprogram")) {
      return "WechatMiniApp";
    } else if (userAgent.includes("iphone")) {
      return "Iphone";
    } else if (userAgent.includes("android")) {
      return "Android";
    } else {
      return "Outro";
    }
  },
};

export default func;
